module.exports = __webpack_public_path__ + "static/img/img_light_2.17c5f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/img_light_2.png
// module id = 8IVW
// module chunks = 1